<nav [class.humbugger-open]="phoneMenuOpen || noticeMenuOpen" class="navbar-origin" [class.navbar-origin-rsv]="isCurrentPath('individual')">
<div class="nav-wrapper" [class.nav-wrapper-rsv]="isCurrentPath('individual')">
  <!-- PC、タブレットのみ -->
  <section id="only-pc-tablet" class="row no-gutters">
    <div *ngIf="utilServ.uTrans.asyncRequesting >= 1" class="loading-progress-bar">
      <div class="loading-progress-bar-child"></div>
    </div>

    <div id="title" class="col-auto mr-auto d-flex">
      <ng-container *ngIf="authServ.smile9Role !== SMILE9_ROLES.SYSTEM">
        <a class="navbar-brand" routerLink=""><img class="app-logo" src="./assets/images/navbar_icon_smile9.png"></a>
        <p class="title">クラウド型給食予約サービス　Smile9</p>
      </ng-container>
      <ng-container *ngIf="authServ.smile9Role === SMILE9_ROLES.SYSTEM">
        <a class="navbar-brand" routerLink=""><img [src]="utilServ.uUI.icongram('clarity','cog')" class="app-logo"></a>
        <p class="title">smile9　開発者用ページ</p>
      </ng-container>

    </div>
    <div id="menu" class="col-auto d-flex">
      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" id="" class="item dd-menu-link-master">
        <div [class.item-link-current-path]="isCurrentPath('reservation')" class="item-link" (click)="dropdownSwitch('isOpenMenuGaRsv')">
          <a>予約</a>
        </div>
        <ng-container *ngIf="isOpenMenuGaRsv">
          <div id="dd-menu-master" class="dd-menu-no-side row shadow bg-white text-left">
            <div class="col-12 pr-0 pl-0 pt-1 pb-1 dd-right" (click)="dropdownSwitch('isOpenMenuGaRsv')">
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD" class="dd-item" routerLink="/general-affairs/reservation/ga-dashboard">
                <img [src]="utilServ.uUI.icongram('fontawesome','th-large')" class="navbar-icon">ダッシュボード
                <p class="fukidashi">任意にカスタマイズした集計単位で予約状況を確認できます。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/ga-rsv-result">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">予約実績リスト
                <p class="fukidashi">指定した期間の予約・実績・キャンセルの数量をリストで閲覧します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/ga-rsv-status">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">予約状況リスト
                <p class="fukidashi">指定した日付の社員別の予約・実績・キャンセルの数量をリストで閲覧します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/ga-individual-rsv-status">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">個人予約状況リスト
                <p class="fukidashi">特定社員の予約・実績・キャンセルの数量を期間指定して閲覧します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/display-rsv-log">
                <img [src]="utilServ.uUI.icongram('material','history')" class="navbar-icon">予約ログ照会
                <p class="fukidashi">各機能から実施された予約データ更新の履歴を閲覧します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/rsv-log">
                <img [src]="utilServ.uUI.icongram('material','history')" class="navbar-icon">いただきますログ照会
                <p class="fukidashi">いただきます端末で実施された予約・実績データの更新履歴を閲覧します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/ga-input-rsv">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">予約入力
                <p class="fukidashi">本日以降の特定社員の予約入力を総務で代行します。<br>通常の予約入力と異なり、予約締切超過後にも予約が可能です。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/bulk-rsv">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">予約一括入力
                <p class="fukidashi">特定社員の予約入力を一括で総務で代行します。<br>通常の予約入力と異なり、予約締切超過後にも予約が可能です。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/ga-edit-rsv">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">予約編集
                <p class="fukidashi">過去の特定社員の予約・実績データを追加・修正します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/update-in-bulk">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">予約一括編集
                <p class="fukidashi">昨日以前の特定社員の予約・実績データを一括で追加・修正します。</p>
              </div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="dd-item" routerLink="/general-affairs/reservation/modify-regi-result">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">セルフレジ実績編集
                <p class="fukidashi">セルフレジ実績を新規登録・修正します。</p>
              </div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="dd-item" routerLink="/general-affairs/reservation/ga-selfregi-rsv-result">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">セルフレジ実績リスト
                <p class="fukidashi">指定した期間のセルフレジ実績数・キャンセル数を閲覧します。</p>
              </div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="dd-item" routerLink="/general-affairs/reservation/ga-individual-regi-rsv-status">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">個人セルフレジ実績リスト
                <p class="fukidashi">特定社員のセルフレジ実績数・キャンセル数を期間指定して閲覧します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/reservation/retire-rsv">
                <img [src]="utilServ.uUI.icongram('octicons','package')" class="navbar-icon">退職者予約整理
                <p class="fukidashi">退職した社員の予約データをまとめて取消・キャンセルします。</p>
              </div>
            </div>
          </div>
          <div id="dd-menu-canseler" (click)="dropdownSwitch('isOpenMenuGaRsv')"></div>
        </ng-container>
      </div>
      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" id="" class="item dd-menu-link-master">
        <div [class.item-link-current-path]="isCurrentPath('general-affairs')" class="item-link" (click)="dropdownSwitch('isOpenMenuGaGa')">
          <a>総務</a>
        </div>
        <ng-container *ngIf="isOpenMenuGaGa">
          <div id="dd-menu-master" class="dd-menu-no-side row shadow bg-white text-left">
            <div class="col-12 pr-0 pl-0 pt-1 pb-1 dd-right" (click)="dropdownSwitch('isOpenMenuGaGa')">
              <div class="dd-item" routerLink="/general-affairs/general-affairs/automenu">
                <img [src]="utilServ.uUI.icongram('material','silverware-fork-knife')" class="navbar-icon">自動メニュー登録
                <p class="fukidashi">予め登録メニューをここで設定しておくことで、自動的にメニューが登録されるようになります。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/general-affairs/ga-menu-list">
                <img [src]="utilServ.uUI.icongram('material','silverware-fork-knife')" class="navbar-icon">食堂メニューリスト
                <p class="fukidashi">登録中のメニューの閲覧、登録、修正をします。</p>
              </div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_RSV" class="dd-item" routerLink="/general-affairs/general-affairs/ga-modify-rsv">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">予約調整入力
                <p class="fukidashi">指定した日付のメニューに調整予約データを追加します。<br>追加した予約データは現在サインイン中の総務ユーザーの予約として作成されます。</p>
              </div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_ATE" class="dd-item" routerLink="/general-affairs/general-affairs/modify-result">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">実績調整入力
                <p class="fukidashi">指定した日付のメニューに調整実績データを追加します。<br>追加した実績データは現在サインイン中の総務ユーザーの実績として作成されます。</p>
              </div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_FAXMAIL_SETTINGS" class="dd-item" routerLink="/general-affairs/general-affairs/faxmail-settings">
                <img [src]="utilServ.uUI.icongram('material','content-save-move-outline')" class="navbar-icon">FAXメール送信設定
                <p class="fukidashi">FAXやメールの自動送信・手動送信の設定をします。<br>給食センターへ予約数を自動送信する際などに設定をします。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/general-affairs/dl-data">
                <img [src]="utilServ.uUI.icongram('entypo','download')" class="navbar-icon">データDL
                <p class="fukidashi">給与連携データ及び経理参考資料データをダウンロードします。<br>出力されるデータはご契約時にご指定頂いた形式となります。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/general-affairs/dl-data-custom">
                <img [src]="utilServ.uUI.icongram('entypo','download')" class="navbar-icon">データDLカスタマイザ
                <p class="fukidashi">ご利用者様自身でフォーマットを設定し、給与連携データや月次資料の為のデータを照会・出力できます。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/general-affairs/guest-info">
                <img [src]="utilServ.uUI.icongram('material','account-tie')" class="navbar-icon">ゲスト情報リスト
                <p class="fukidashi">ゲスト情報を登録・修正します。<br>定期的に利用されるゲストの情報を登録するとゲスト予約時のゲスト会社名・ゲスト社員名などの入力を省略できます。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/general-affairs/register-felica">
                <img [src]="utilServ.uUI.icongram('material', 'badge-account-horizontal-outline')" class="navbar-icon">Smile9ID登録
                <p class="fukidashi">ICカード、磁気カード、QRコードなどの値を各社員に対し割り当てます。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/general-affairs/edit-notice">
                <img [src]="utilServ.uUI.icongram('fontawesome','bell-o')" class="navbar-icon">通知編集
                <p class="fukidashi">個人ユーザー・総務担当・給食センターに対し、通知メッセージを送信します。</p>
              </div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE" class="dd-item" routerLink="/general-affairs/general-affairs/ga-nutrition-balance">
                <img [src]="utilServ.uUI.icongram('fontawesome','tachometer')" class="navbar-icon">栄養バランス
                <p class="fukidashi">個人ユーザーの摂取した栄養価情報を確認、出力することができます。</p>
              </div>
            </div>
          </div>
          <div id="dd-menu-canseler" (click)="dropdownSwitch('isOpenMenuGaGa')"></div>
        </ng-container>
      </div>
      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" id="nav-menu-master" class="item dd-menu-link-master">
        <div [class.item-link-current-path]="isCurrentPath('master')" class="item-link" (click)="dropdownSwitch('isOpenMenuGaMaster')">
          <a>管理</a>
        </div>
        <ng-container *ngIf="isOpenMenuGaMaster">
          <div id="dd-menu-master" class="dd-menu row shadow bg-white text-left">
            <div class="col-4 pr-0 pl-0 pt-3 dd-right" (click)="dropdownSwitch('isOpenMenuGaMaster')">
              <div class="dd-sub-name">基本情報</div>
              <div class="dd-item" routerLink="/general-affairs/master/company">
                <img [src]="utilServ.uUI.icongram('clarity','building')" class="navbar-icon">会社リスト
                <p class="fukidashi">会社情報を登録・修正します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/master/department">
                <img [src]="utilServ.uUI.icongram('clarity','organization')" class="navbar-icon">部署リスト
                <p class="fukidashi">部署情報を登録・修正します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/master/employee">
                <img [src]="utilServ.uUI.icongram('material', 'account')" class="navbar-icon">社員リスト
                <p class="fukidashi">社員情報を登録・修正します。<br>新入社員が入ったり、既存社員の社員形態変更・退職などがあった場合などにはこの情報を更新します。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/master/import-emp-csv">
                <img [src]="utilServ.uUI.icongram('material', 'account')" class="navbar-icon">社員CSV取込
                <p class="fukidashi">社員情報をCSVファイルから登録・修正します。<br>大量の社員データを更新する際に便利です。</p>
              </div>
              <div class="dd-item" routerLink="/general-affairs/master/holiday-pattern">
                <img [src]="utilServ.uUI.icongram('material', 'domain-off')" class="navbar-icon">休日パターン設定
                <p class="fukidashi">会社の休日情報を登録・修正します。<br>予めこの設定をしておくと食堂営業日カレンダーの設定を効率化できます。</p>
              </div>
            </div>
            <div class="col pr-0 pl-0 pt-3 pb-3 dd-right" (click)="dropdownSwitch('isOpenMenuGaMaster')">
              <div class="dd-sub-name">Smile9情報</div>
              <div class="row">
                <div class="col">
                  <div class="dd-item" routerLink="/general-affairs/master/cafeteria">
                    <img [src]="utilServ.uUI.icongram('feather','home')" class="navbar-icon">食堂リスト
                    <p class="fukidashi">食堂情報を登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/cafe-opening-hours">
                    <img [src]="utilServ.uUI.icongram('feather','home')" class="navbar-icon">食堂設定
                    <p class="fukidashi">食堂の営業時間・締切・利用可能な食堂機能を設定します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/bill">
                    <img [src]="utilServ.uUI.icongram('feather','file-text')" class="navbar-icon">請求先リスト
                    <p class="fukidashi">請求先情報を登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/cafe-bill">
                    <img [src]="utilServ.uUI.icongram('feather','file-text')" class="navbar-icon">食堂請求先設定
                    <p class="fukidashi">食堂別の請求先情報を登録・修正します。</p>
                  </div>
                  <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.DISPLAY_GA_ITADAKIMASU_SETTINGS" class="dd-item" routerLink="/general-affairs/master/itadakimasu-settings">
                    <img [src]="utilServ.uUI.icongram('clarity','tablet')" class="navbar-icon">いただきます端末設定
                    <p class="fukidashi">いただきます端末毎の設定値を編集します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/cafe-business-calendar">
                    <img [src]="utilServ.uUI.icongram('clarity','calendar')" class="navbar-icon">食堂営業日カレンダー
                    <p class="fukidashi">食堂営業時間別に食堂営業日・締切カウント日を設定します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/disp-price">
                    <img [src]="utilServ.uUI.icongram('material','currency-cny')" class="navbar-icon">価格表示設定
                    <p class="fukidashi">価格を画面に表示するかどうかを各食堂機能別に設定します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/sei-kbn">
                    <img [src]="utilServ.uUI.icongram('material','cash')" class="navbar-icon">請求区分リスト
                    <p class="fukidashi">請求区分を登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/menu-type">
                    <img [src]="utilServ.uUI.icongram('material','silverware-fork-knife')" class="navbar-icon">メニュー種類設定
                    <p class="fukidashi">メニュー種類を登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/menu-tanka">
                    <img [src]="utilServ.uUI.icongram('material','currency-cny')" class="navbar-icon">メニュー単価設定
                    <p class="fukidashi">メニュー単価を登録・修正します。</p>
                  </div>
                </div>
                <div class="col">
                  <div class="dd-item" routerLink="/general-affairs/master/cafe-hojo-group">
                    <img [src]="utilServ.uUI.icongram('material','account-star')" class="navbar-icon">補助食堂グループリスト
                    <p class="fukidashi">補助食堂グループを登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/cafe-hojo-settings">
                    <img [src]="utilServ.uUI.icongram('material','account-star')" class="navbar-icon">補助食堂設定
                    <p class="fukidashi">補助食堂を登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/menu-pattern">
                    <img [src]="utilServ.uUI.icongram('material','silverware-fork-knife')" class="navbar-icon">メニューパターン設定
                    <p class="fukidashi">メニューパターンを登録・修正します。</p>
                  </div>
                  <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="dd-item" routerLink="/general-affairs/master/sub-menu-group">
                    <img [src]="utilServ.uUI.icongram('material','silverware-fork')" class="navbar-icon">サブメニューグループ<br>　　リスト
                    <p class="fukidashi">サブメニューグループを登録・修正します。</p>
                  </div>
                  <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="dd-item" routerLink="/general-affairs/master/sub-menu-pattern">
                    <img [src]="utilServ.uUI.icongram('material','silverware-fork')" class="navbar-icon">サブメニューパターン<br>　　設定
                    <p class="fukidashi">サブメニューパターンを登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/cafe-available-group">
                    <img [src]="utilServ.uUI.icongram('material','home-lock-open')" class="navbar-icon">利用食堂グループリスト
                    <p class="fukidashi">利用食堂グループを登録・修正します。</p>
                  </div>
                  <div class="dd-item" routerLink="/general-affairs/master/cafe-available-settings">
                    <img [src]="utilServ.uUI.icongram('material','home-lock-open')" class="navbar-icon">利用食堂設定
                    <p class="fukidashi">利用食堂を登録・修正します。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="dd-menu-canseler" (click)="dropdownSwitch('isOpenMenuGaMaster')"></div>
        </ng-container>
      </div>

      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" id="" class="item dd-menu-link-master">
        <div [class.item-link-current-path]="true" class="item-link" (click)="dropdownSwitch('isOpenMenuFsc')">
          <a>メニュー</a>
        </div>
        <ng-container *ngIf="isOpenMenuFsc">
          <div id="dd-menu-master" class="dd-menu-no-side row shadow bg-white text-left">
            <div class="col-12 pr-0 pl-0 pt-1 pb-1 dd-right" (click)="dropdownSwitch('isOpenMenuFsc')">
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD" class="dd-item" routerLink="/fsc/fsc-dashboard">
                <img [src]="utilServ.uUI.icongram('fontawesome','th-large')" class="navbar-icon">ダッシュボード
                <p class="fukidashi">任意にカスタマイズした集計単位で予約状況を確認できます。</p>
              </div>
              <div class="dd-item" routerLink="/fsc/fsc-rsv-result">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">予約実績リスト
                <p class="fukidashi">指定した期間の予約・実績・キャンセルの数量をリストで閲覧します。</p>
              </div>
              <div class="dd-item" routerLink="/fsc/import-menu-csv">
                <img [src]="utilServ.uUI.icongram('material','file-upload-outline')" class="navbar-icon">食堂メニューCSV取込
                <p class="fukidashi">CSVファイルから複数日付分のメニューデータをまとめて作成します。</p>
              </div>
              <div class="dd-item" routerLink="/fsc/menu-list">
                <img [src]="utilServ.uUI.icongram('material','silverware-fork-knife')" class="navbar-icon">食堂メニューリスト
                <p class="fukidashi">食堂メニューを登録・修正します。</p>
              </div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="dd-item" routerLink="/fsc/sub-menu-list">
                <img [src]="utilServ.uUI.icongram('material','silverware-fork')" class="navbar-icon">サブメニューリスト
                <p class="fukidashi">サブメニューを登録・修正します。</p>
              </div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="dd-item" routerLink="/fsc/sub-menu-settings">
                <img [src]="utilServ.uUI.icongram('material','silverware-fork')" class="navbar-icon">サブメニュー設定
                <p class="fukidashi">サブメニュー設定を登録・修正します。<br>サブメニュー設定をすると、メニューを新規登録した際に自動的にサブメニューも一緒に登録されるようになります。</p>
              </div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="dd-item" routerLink="/fsc/self-regi-menu-list">
                <img [src]="utilServ.uUI.icongram('material','cash-register')" class="navbar-icon">セルフレジメニューリスト
                <p class="fukidashi">セルフレジメニューを登録・修正します。</p>
              </div>
              <div class="dd-item" routerLink="/fsc/kondate-list">
                <img [src]="utilServ.uUI.icongram('material','silverware-fork-knife')" class="navbar-icon">献立リスト
                <p class="fukidashi">献立を登録・修正します。</p>
              </div>
              <div class="dd-item" routerLink="/fsc/kondate-class-list">
                <img [src]="utilServ.uUI.icongram('material','silverware-fork-knife')" class="navbar-icon">献立分類リスト
                <p class="fukidashi">献立分類を登録・修正します。</p>
              </div>
              <div class="dd-item" routerLink="/fsc/kondate-otomo-list">
                <img [src]="utilServ.uUI.icongram('material','plus-box-multiple-outline')" class="navbar-icon">オトモ献立リスト
                <p class="fukidashi">オトモ献立の設定を登録・修正します。<br>オトモ献立を登録すると、CSV取込時に特定メニューを登録すると自動的に指定したメニューも一緒に登録されるようになります。</p>
              </div>
              <!--<div class="dd-item" routerLink="/fsc/print-invoice">請求書印刷</div>-->
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="dd-item" routerLink="/fsc/fsc-selfregi-rsv-result">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">セルフレジ実績リスト
                <p class="fukidashi">指定した期間のセルフレジ実績数・キャンセル数を閲覧します。</p>
              </div>
            </div>
          </div>
          <div id="dd-menu-canseler" (click)="dropdownSwitch('isOpenMenuFsc')"></div>
        </ng-container>
      </div>

      <div *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL" id="" class="item dd-menu-link-master">
        <div [class.item-link-current-path]="true" class="item-link" (click)="dropdownSwitch('isOpenMenuIndividual')">
          <a>メニュー</a>
        </div>
        <ng-container *ngIf="isOpenMenuIndividual">
          <div id="dd-menu-master" class="dd-menu-no-side row shadow bg-white text-left">
            <div class="col-12 pr-0 pl-0 pt-1 pb-1 dd-right" (click)="dropdownSwitch('isOpenMenuIndividual')">
              <div *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="dd-item" routerLink="/individual/reservation-list">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">予約リスト
              </div>
              <div *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="dd-item" routerLink="/individual/input-reservation">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">予約入力
              </div>
              <div *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="dd-item" routerLink="/individual/indi-rsv-calendar">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">予約カレンダー
              </div>
              <div *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="dd-item" routerLink="/individual/auto-rsv-settings">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">自動予約設定
              </div>
              <div *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
                !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="dd-item" routerLink="/individual/g-reservation-list">
                <img [src]="utilServ.uUI.icongram('clarity','view-list')" class="navbar-icon">ゲスト予約リスト</div>
              <div *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
                !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="dd-item" routerLink="/individual/g-input-reservation">
                <img [src]="utilServ.uUI.icongram('fontawesome','edit')" class="navbar-icon">ゲスト予約入力</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="dd-item" routerLink="/individual/selfregi-usage-history">
                <img [src]="utilServ.uUI.icongram('material','cash-register')" class="navbar-icon">セルフレジ利用履歴</div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE" class="dd-item" routerLink="/individual/nutrition-balance">
                <img [src]="utilServ.uUI.icongram('fontawesome','tachometer')" class="navbar-icon">栄養バランス
              </div>
            </div>
          </div>
          <div id="dd-menu-canseler" (click)="dropdownSwitch('isOpenMenuIndividual')"></div>
        </ng-container>
      </div>

      <!-- 通知 -->
      <div class="float-left notice-bell" [class.notice-bell-not-exist]="navbarServ.noticeList.length === 0" (click)="navbarServ.openNoticeModal($event)">
        <div class="notice-bell-inner" [class.swing]="navbarServ.swingOnce && navbarServ.notReadCount > 0">
          <img class="bell" [src]="navbarServ.noticeImgSrc">
        </div>
        <div *ngIf="navbarServ.notReadCount > 0" class="notice-count">
          <ng-container *ngIf="navbarServ.notReadCount <= 99">{{navbarServ.notReadCount}}</ng-container>
          <ng-container *ngIf="navbarServ.notReadCount >= 100">#</ng-container>
        </div>
      </div>

      <!-- いただきます端末の個人予約画面のみ -->
      <ng-container *ngIf="authServ.isKitchenRsvTerm">
        <div class="kitchen-rsv-term-account d-flex">
          <div class="account-name">
            <div class="">{{this.authServ.coName}}</div>
            <div class="emp-name">{{this.authServ.empName}} 様</div>
          </div>
          <div class="btn">
            <button class="btn btn-success btn-block btn-signout" (click)="itadakimasuSignOut()">サインアウト</button>
          </div>
        </div>
      </ng-container>

      <div class="account" [class.account-rsv]="isCurrentPath('individual')" [class.d-none]="authServ.smile9Role === SMILE9_ROLES.ITADAKIMASU || authServ.isKitchenRsvTerm"
           (click)="accountMenuOpen === true ? acMenuClose($event) : acMenuOpen($event)"
           (mouseenter)="acMenuOpen($event)"
           (mouseleave)="accountMenuOpen = false;">

        <!-- タブレット画面のみ -->
        <div class="phone-d-none middle-d-disp account-icon"><span class="oi oi-person person" aria-hidden="true"></span></div>

        <!-- PC画面のみ -->
        <div class="middle-d-none account-inner">
          <div class="col-2 float-left account-icon">
            <span class="oi oi-person person" aria-hidden="true"></span>
          </div>
          <div class="col-10 float-left">
            <span class="d-block">{{this.authServ.coName}}</span>
            <span class="d-block pl-4">{{this.authServ.empName}} 様</span>
          </div>
        </div>

        <div [class.d-none]="!accountMenuOpen" class="account-menu">
          <!-- タブレット画面のみ -->
          <div class="phone-d-none middle-d-disp am-item-middle add-border-bottom">
            <div class="account-info">
              <div>{{this.authServ.coName}}</div>
              <div>{{this.authServ.empName}} 様</div>
            </div>
          </div>

          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" class="am-item" routerLink="/mailchange">
            メールアドレス変更
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" class="am-item" routerLink="/pwchange">
            パスワード変更
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL" class="am-item" (click)="openRegisterFavPage()">
            <span class="oi oi-star pr-2"></span>お気に入り登録
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL" class="am-item" routerLink="/individual/personal-data">
            個人情報設定
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" class="am-item" (click)="openMainUserGuide()">
            <span class="oi oi-external-link"></span> Smile9ご利用ガイド
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" class="am-item" (click)="openFscUserGuide()">
            <span class="oi oi-external-link"></span> Smile9ご利用ガイド(給食会社様向け)
          </div>
          <div class="am-item" (click)="linkUrl(SKS_WEBSITE + 'archives/528')">
            推奨環境
          </div>
          <div *ngIf="authServ.smile9Role !== SMILE9_ROLES.KITCHEN" class="am-item text-primary" (click)="normalSignOut()" (click)="acMenuClose($event)">
            <span class="oi oi-account-logout account-logout pr-2" aria-hidden="true"></span>サインアウト
          </div>
          <div *ngIf="authServ.smile9Role === SMILE9_ROLES.KITCHEN" class="am-item text-primary" (click)="itadakimasuSignOut()" (click)="acMenuClose($event)">
            <span class="oi oi-account-logout account-logout pr-2" aria-hidden="true"></span>サインアウト
          </div>
          <div class="am-item text-center" (click)="acMenuClose($event)">
            <span class="oi oi-x" aria-hidden="true"></span>　閉じる
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- スマホのみ -->
  <section id="only-phone">
    <div>
      <div *ngIf="utilServ.uTrans.asyncRequesting >= 1" class="loading-progress-bar">
        <div class="loading-progress-bar-child"></div>
      </div>
      <div class="row row-no-padding">
        <div class="col-auto mr-auto p-0">
          <a class="navbar-brand" routerLink=""><img class="app-logo" src="./assets/images/navbar_icon_smile9.png"></a>
        </div>
        <div class="col-auto p-0">
          <div>
            <!-- 通知 -->
            <div class="float-left notice-bell" [class.notice-bell-not-exist]="navbarServ.noticeList.length === 0" (click)="navbarServ.openNoticeModal($event)">
              <div class="notice-bell-inner" [class.swing]="navbarServ.swingOnce && navbarServ.notReadCount > 0">
                <img class="bell" [src]="navbarServ.noticeImgSrc">
              </div>
              <div *ngIf="navbarServ.notReadCount > 0" class="notice-count">
                <ng-container *ngIf="navbarServ.notReadCount <= 99">{{navbarServ.notReadCount}}</ng-container>
                <ng-container *ngIf="navbarServ.notReadCount >= 100">#</ng-container>
              </div>
            </div>

            <div class="float-right humbugger menu-icon" [class.invisible]="authServ.smile9Role === SMILE9_ROLES.ITADAKIMASU">
              <div *ngIf="!phoneMenuOpen" class="humbugger-child" (click)="phoneMenuSwitch()"><span class="oi oi-menu" aria-hidden="true"></span></div>
              <div *ngIf="phoneMenuOpen" class="humbugger-child" (click)="phoneMenuSwitch()"><span class="oi oi-x" aria-hidden="true"></span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="phoneMenuOpen">
    <div id="phone-nav">
      <div class="account">
        <div class="account-inner row">
        <div class="col-2 float-left account-icon text-left">
          <span class="oi oi-person person" aria-hidden="true"></span>
        </div>
        <div class="col-10 float-left account-name">
          <span class="d-block">{{this.authServ.coName}}</span>
          <span class="d-block pl-4">{{this.authServ.empName}} 様</span>
        </div>
        </div>
      </div>
      <div class="add-border only"></div>
      <div id="phone-menu">
        <ng-container *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS">
          <div [class.add-border]="!isOpenMenuGaRsv" class="item row" (click)="dropdownSwitch('isOpenMenuGaRsv')">
            <div class="item-link col-auto mr-auto">予約</div>
            <div class="col-auto">
              <span *ngIf="isOpenMenuGaRsv === false" class="oi oi-chevron-bottom" aria-hidden="true"></span>
              <span *ngIf="isOpenMenuGaRsv === true" class="oi oi-chevron-top" aria-hidden="true"></span>
            </div>
          </div>
          <ng-container *ngIf="isOpenMenuGaRsv">
            <div class="item-bg-main">
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD" class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/ga-dashboard" (click)="closePhoneMenu()">ダッシュボード</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/ga-rsv-result" (click)="closePhoneMenu()">予約実績リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/ga-rsv-status" (click)="closePhoneMenu()">予約状況リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/ga-individual-rsv-status" (click)="closePhoneMenu()">個人予約状況リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/display-rsv-log" (click)="closePhoneMenu()">予約ログ照会</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/rsv-log" (click)="closePhoneMenu()">いただきますログ照会</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/ga-input-rsv" (click)="closePhoneMenu()">予約入力</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/bulk-rsv" (click)="closePhoneMenu()">予約一括入力</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/ga-edit-rsv" (click)="closePhoneMenu()">予約編集</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/update-in-bulk" (click)="closePhoneMenu()">予約一括編集</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/modify-regi-result" (click)="closePhoneMenu()">セルフレジ実績編集</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/ga-selfregi-rsv-result" (click)="closePhoneMenu()">セルフレジ実績リスト</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="item-bg-main-c" routerLink="/general-affairs/reservation/ga-individual-regi-rsv-status" (click)="closePhoneMenu()">個人セルフレジ実績リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/reservation/retire-rsv" (click)="closePhoneMenu()">退職者予約整理</div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS">
          <div [class.add-border]="!isOpenMenuGaGa" class="item row" (click)="dropdownSwitch('isOpenMenuGaGa')">
            <div class="item-link col-auto mr-auto">総務</div>
            <div class="col-auto">
              <span *ngIf="isOpenMenuGaGa === false" class="oi oi-chevron-bottom" aria-hidden="true"></span>
              <span *ngIf="isOpenMenuGaGa === true" class="oi oi-chevron-top" aria-hidden="true"></span>
            </div>
          </div>
          <ng-container *ngIf="isOpenMenuGaGa">
            <div class="item-bg-main">
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/automenu" (click)="closePhoneMenu()">自動メニュー登録</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/ga-menu-list" (click)="closePhoneMenu()">食堂メニューリスト</div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_RSV" class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/ga-modify-rsv" (click)="closePhoneMenu()">予約調整入力</div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_GA_MODIFY_ATE" class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/modify-result" (click)="closePhoneMenu()">実績調整入力</div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_FAXMAIL_SETTINGS" class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/faxmail-settings" (click)="closePhoneMenu()">FAXメール送信設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/dl-data" (click)="closePhoneMenu()">データDL</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/dl-data-custom" (click)="closePhoneMenu()">データDLカスタマイザ</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/guest-info" (click)="closePhoneMenu()">ゲスト情報リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/register-felica" (click)="closePhoneMenu()">Smile9ID登録</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/general-affairs/edit-notice" (click)="closePhoneMenu()">通知編集</div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE" class="item-bg-main-c" routerLink="/general-affairs/general-affairs/ga-nutrition-balance" (click)="closePhoneMenu()">栄養バランス</div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS">
          <div [class.add-border]="!isOpenMenuGaMaster" class="item row" (click)="dropdownSwitch('isOpenMenuGaMaster')">
            <div class="item-link col-auto mr-auto">管理</div>
            <div class="col-auto">
              <span *ngIf="isOpenMenuGaMaster === false" class="oi oi-chevron-bottom" aria-hidden="true"></span>
              <span *ngIf="isOpenMenuGaMaster === true" class="oi oi-chevron-top" aria-hidden="true"></span>
            </div>
          </div>
          <ng-container *ngIf="isOpenMenuGaMaster">
            <div class="item-bg-sub">基本情報</div>
            <div class="item-bg-main">
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/company" (click)="closePhoneMenu()">会社リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/department" (click)="closePhoneMenu()">部署リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/employee" (click)="closePhoneMenu()">社員リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/import-emp-csv" (click)="closePhoneMenu()">社員CSV取込</div>
              <div class="item-bg-main-c" routerLink="/general-affairs/master/holiday-pattern" (click)="closePhoneMenu()">休日パターン設定</div>
            </div>
            <div class="item-bg-sub">Smile9情報</div>
            <div class="item-bg-main">
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/cafeteria" (click)="closePhoneMenu()">食堂リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/cafe-opening-hours" (click)="closePhoneMenu()">食堂設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/bill" (click)="closePhoneMenu()">請求先リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/cafe-bill" (click)="closePhoneMenu()">食堂請求先設定</div>
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.DISPLAY_GA_ITADAKIMASU_SETTINGS" class="item-bg-main-c add-border" routerLink="/general-affairs/master/itadakimasu-settings" (click)="closePhoneMenu()">いただきます端末設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/cafe-business-calendar" (click)="closePhoneMenu()">食堂営業日カレンダー</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/disp-price" (click)="closePhoneMenu()">価格表示設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/sei-kbn" (click)="closePhoneMenu()">請求区分リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/menu-type" (click)="closePhoneMenu()">メニュー種類設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/menu-tanka" (click)="closePhoneMenu()">メニュー単価設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/cafe-hojo-group" (click)="closePhoneMenu()">補助食堂グループリスト</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/cafe-hojo-settings" (click)="closePhoneMenu()">補助食堂設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/menu-pattern" (click)="closePhoneMenu()">メニューパターン設定</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="item-bg-main-c add-border" routerLink="/general-affairs/master/sub-menu-group" (click)="closePhoneMenu()">サブメニューグループリスト</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="item-bg-main-c add-border" routerLink="/general-affairs/master/sub-menu-pattern" (click)="closePhoneMenu()">サブメニューパターン設定</div>
              <div class="item-bg-main-c add-border" routerLink="/general-affairs/master/cafe-available-group" (click)="closePhoneMenu()">利用食堂グループリスト</div>
              <div class="item-bg-main-c" routerLink="/general-affairs/master/cafe-available-settings" (click)="closePhoneMenu()">利用食堂設定</div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC">
          <div [class.add-border]="!isOpenMenuFsc" class="item row" (click)="dropdownSwitch('isOpenMenuFsc')">
            <div class="item-link col-auto mr-auto">メニュー</div>
            <div class="col-auto">
              <span *ngIf="isOpenMenuFsc === false" class="oi oi-chevron-bottom" aria-hidden="true"></span>
              <span *ngIf="isOpenMenuFsc === true" class="oi oi-chevron-top" aria-hidden="true"></span>
            </div>
          </div>
          <ng-container *ngIf="isOpenMenuFsc">
            <div class="item-bg-main">
              <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_DASHBOARD" class="item-bg-main-c add-border" routerLink="/fsc/fsc-dashboard" (click)="closePhoneMenu()">ダッシュボード</div>
              <div class="item-bg-main-c add-border" routerLink="/fsc/fsc-rsv-result" (click)="closePhoneMenu()">予約実績リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/fsc/import-menu-csv" (click)="closePhoneMenu()">食堂メニューCSV取込</div>
              <div class="item-bg-main-c add-border" routerLink="/fsc/menu-list" (click)="closePhoneMenu()">食堂メニューリスト</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="item-bg-main-c add-border" routerLink="/fsc/sub-menu-list" (click)="closePhoneMenu()">サブメニューリスト</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'sub_menu'" class="item-bg-main-c add-border" routerLink="/fsc/sub-menu-settings" (click)="closePhoneMenu()">サブメニュー設定</div>
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="item-bg-main-c add-border" routerLink="/fsc/self-regi-menu-list" (click)="closePhoneMenu()">セルフレジメニューリスト</div>
              <div class="item-bg-main-c add-border" routerLink="/fsc/kondate-list" (click)="closePhoneMenu()">献立リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/fsc/kondate-class-list" (click)="closePhoneMenu()">献立分類リスト</div>
              <div class="item-bg-main-c add-border" routerLink="/fsc/kondate-otomo-list" (click)="closePhoneMenu()">オトモ献立リスト</div>
              <!-- <div class="item-bg-main-c add-border" routerLink="/fsc/print-invoice" (click)="closePhoneMenu()">請求書印刷</div> -->
              <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="item-bg-main-c" routerLink="/fsc/fsc-selfregi-rsv-result" (click)="closePhoneMenu()">セルフレジ実績リスト</div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL">
          <div *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="item add-border" routerLink="/individual/reservation-list" (click)="closePhoneMenu()"><div class="item-link">予約リスト</div></div>
          <div *ngIf="!authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="item add-border" routerLink="/individual/input-reservation" (click)="closePhoneMenu()"><div class="item-link">予約入力</div></div>
          <div *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="item add-border" routerLink="/individual/indi-rsv-calendar" (click)="closePhoneMenu()"><div class="item-link">予約カレンダー</div></div>
          <div *ngIf="authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="item add-border" routerLink="/individual/auto-rsv-settings" (click)="closePhoneMenu()"><div class="item-link">自動予約設定</div></div>
          <div *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
            !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="item add-border" routerLink="/individual/g-reservation-list" (click)="closePhoneMenu()"><div class="item-link">ゲスト予約リスト</div></div>
          <div *ngIf="authServ.guestReservationAuth === GUEST_RESERVATION_AUTH.AUTHORIZED &&
            !authServ.isSetSmile9UserSettings(SMILE9_USER_SETTINGS.ALLOW_RSV_CALENDAR, '1')" class="item add-border" routerLink="/individual/g-input-reservation" (click)="closePhoneMenu()"><div class="item-link">ゲスト予約入力</div></div>
          <div *ngIf="authServ.userGroupOptions | isSetUgOptionPipe : 'self_regi'" class="item add-border" routerLink="/individual/selfregi-usage-history" (click)="closePhoneMenu()"><div class="item-link">セルフレジ利用履歴</div></div>
          <div *ngIf="authServ.smile9UserSettings | isSetSmile9UserSettingsPipe : SMILE9_USER_SETTINGS.ALLOW_NUTRITION_BALANCE" class="item add-border" routerLink="/individual/nutrition-balance" (click)="closePhoneMenu()"><div class="item-link">栄養バランス</div></div>
        </ng-container>


        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" class="item add-border" routerLink="/mailchange" (click)="closePhoneMenu()">メールアドレス変更</div>
        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" class="item add-border" routerLink="/pwchange" (click)="closePhoneMenu()">パスワード変更</div>
        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL" class="item add-border" (click)="openRegisterFavPage()"><span class="oi oi-star pr-2"></span>お気に入り登録</div>
        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.INDIVIDUAL" class="item add-border" routerLink="/individual/personal-data" (click)="closePhoneMenu()"><div class="item-link">個人情報設定</div></div>

        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.GENERAL_AFFAIRS" class="item add-border" (click)="openMainUserGuide()">
          <div class="item-link">
            <span class="oi oi-external-link"></span> Smile9ご利用ガイド
          </div>
        </div>
        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.FSC" class="item add-border" (click)="openFscUserGuide()">
          <div class="item-link">
            <span class="oi oi-external-link"></span> Smile9ご利用ガイド(給食会社様向け)
          </div>
        </div>
        <div class="item add-border" (click)="linkUrl(SKS_WEBSITE + 'archives/528')"><div class="item-link">推奨環境</div></div>
        <div *ngIf="authServ.smile9Role !== SMILE9_ROLES.KITCHEN" class="item" (click)="normalSignOut()" (click)="closePhoneMenu()">
          <div class="item-link text-primary"><span class="oi oi-account-logout account-logout pr-2" aria-hidden="true"></span>サインアウト</div>
        </div>
        <div *ngIf="authServ.smile9Role === SMILE9_ROLES.KITCHEN" class="item" (click)="itadakimasuSignOut()" (click)="closePhoneMenu()">
          <div class="item-link text-primary"><span class="oi oi-account-logout account-logout pr-2" aria-hidden="true"></span>サインアウト</div>
        </div>
      </div>
    </div>
    </ng-container>
  </section>
</div>
</nav>

<!-- 通知リストモーダル -->
<article class="modal fade" id="noticeModal" tabindex="-1" role="dialog" aria-labelledby="noticeModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-bg">
      <div class="modal-header modal-h">
        <h5 class="modal-title" id="eraseDetailFormModalLabel">通知一覧</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="navbarServ.readNoticeOnDisplayAsync()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="notice-list-wrap">
          <article *ngFor="let notice of navbarServ.noticeList;" class="notice-list" [class.emergency]="notice.notice_type === 99">
            <div>
              <span *ngIf="notice.is_read === 0" class="badge badge-pill badge-danger">未読</span>
              <span *ngIf="notice.is_read === 2" class="badge badge-pill badge-danger">要対応</span>
              <!-- <span *ngIf="notice.notice_type === 100 && notice.version > navbarServ.currentVer" class="badge badge-pill badge-info">要アップデート</span> -->
            </div>
            <span class="body" [innerHTML]="notice.body"></span>
            <!--
            <div *ngIf="notice.notice_type === 100 && notice.version > navbarServ.currentVer" class="text-right">
              <button class="btn btn-outline-dark pl-2 pr-2" (click)="reloadAsync()">アップデート(ブラウザ更新します)</button>
            </div>
            -->
            <div class="open-period-from">{{notice.open_period_from}}</div>
          </article>
        </div>
        <div>
          <button type="button" class="btn btn-outline-dark btn-block mt-2" data-dismiss="modal" (click)="navbarServ.readNoticeOnDisplayAsync()">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</article>
